var map = {
	"./banner.jpg": "301c",
	"./banner2.jpg": "db49",
	"./bm1.jpeg": "2462",
	"./bm2.jpeg": "89fe",
	"./en.jpeg": "7410",
	"./favicon.png": "8925e",
	"./logo.png": "9d64",
	"./sunday-bm.jpeg": "ed1a",
	"./sunday-en.jpeg": "4163",
	"./sunday.jpg": "a06f",
	"./visitor.jpg": "fcb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";